var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html( "<span class='newsletter__errorWrap'>" + response.msg + "</span>" );
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function () {
  var elements = document.querySelectorAll('.js-gallery');
  if(elements && elements.length>0){
    for(var i=0;i<elements.length;i++){
        $(".js-gallery").eq(i).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '%curr% z %total%'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            }
        });
    }
  }






  // scrolledGallery for mobiles
  let scrolledGallery = function() {
      $('.js-scrolledGallery').slick({
          arrows: true,
          speed: 700,
          fade: true,
          autoplaySpeed: 7000,
          dots: true,
          infinite: true,
          autoplay: false,
          responsive: [
            {
              breakpoint: 1240,
              settings: {
                dots: false,
              }
            }
          ]
      });
  }
  if ($(window).width() < 800) {
      scrolledGallery();
  }
  $(window).on('resize', function(){
      if ($(window).width() < 800) {
          scrolledGallery();
      }
  });

});

$(document).ready(function(){

    var elements = $(".js-videoSlider");

    if( elements.length > 0 ) {

        for(var i=0; i<elements.length;i++){
          $(elements[i]).slick({
              dots: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              responsive: [
              {
                breakpoint: 760,
                settings: {
                 slidesToShow: 3,
               },
               breakpoint: 500,
               settings: {
                slidesToShow: 3,
              }
              }
]
          });
        }



        $('.js-videoSlider').each(function(){
            if ( $(this).find('.slick-slide').length <= 4 ) {
              $(this).closest('.videoSlider').addClass('short');
            }
        });
    }

    $("[data-videourl]").on("click", function () {
        var el = $(this);
        var url = el.data("videourl");
        var instance = el.closest('.videoSlider__bottom').parent();
        instance.find('[data-target]').attr("src", url);
        instance.find('.videoSlide .slick-slide').removeClass('slick-current');
        el.closest('.slick-slide').addClass('slick-current');
    });

    $("[data-videourl]").eq(0).trigger("click");

});

$(document).ready(function(){
    $(".contentBlock").find("table").wrap("<div class='styledTable'></div>");
});



//responsive table
document.querySelectorAll('table').forEach(table => {

  const headers = Array.from(table.querySelectorAll('thead td, thead th'))
        .map(th => th.textContent.trim());

    table.querySelectorAll('tbody tr').forEach(row => {
        Array.from(row.children).forEach((cell, index) => {
            if (headers[index]) {
                cell.setAttribute('data-label', headers[index]);
            }
        });
    });
});

$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {

  // scrolledGallery for mobiles
  let scrolledLogotypes = function() {
      $('.sliderLogotypes').slick({
          arrows: true,
          speed: 700,
          fade: true,
          autoplaySpeed: 7000,
          dots: true,
          slidesToShow:1,
          infinite: true,
          autoplay: false,
      });
  }
  if ($(window).width() < 500) {
      scrolledLogotypes();
  }
  $(window).on('resize', function(){
      if ($(window).width() < 500) {
          scrolledLogotypes();
      }
  });

});

// trainig tabs
console.log('test');
function toggleTrainingsTab() {
  const toggleButtons = $('.trainingTab');


  toggleButtons.on('click', function(event) {
    toggleButtons.removeClass('active');
    $(this).addClass('active');

    const index = toggleButtons.index(this);

    $('.trainingDetails').hide();
    $('.trainingDetails').eq(index).show();
  })
}


// TRAININGS ADD NEW PARTICIPANT

const firstRemoveButton = $(".remove-button-first");
const firstRowInput = $(".iterated-input--first");

  firstRemoveButton.on('click', function() {
      firstRowInput.remove();
  });

let countRegisterRow = 0;
function addInputs() {
  countRegisterRow++;
  const inputDiv = $('<div class="iterated-input row"></div>');

  const labels = trainingLabels;
  const names = ['name', 'phone', 'email'];

  labels.forEach((labelText, index) => {
      const inputItem = $(`<div class="iterated-input__item col-md-4"></div>`);
      const styledForm = $(`<div class="styledForm__row"></div>`);
      const type = names[index] === 'email' ? 'email' : 'text';
      const label = $(`<label for="members[${countRegisterRow}][${names[index]}]" class="styledForm__label">${labelText}</label>`);
      const input = $(`<input type="${type}" id="members[${countRegisterRow}][${names[index]}]" name="members[${countRegisterRow}][${names[index]}]" class="styledFormItems styledFormItems--input" placeholder="${insertLabel}">`);

      styledForm.append(label);
      styledForm.append(input);
      inputItem.append(styledForm);
      inputDiv.append(inputItem);
  });

  const removeButton = $('<button type="button" class="remove-button">X</button>');
  removeButton.on('click', function() {
      inputDiv.remove();
  });

  inputDiv.append(removeButton);
  $('.iterated-inputs').append(inputDiv);
}



$(document).ready(function() {
  toggleTrainingsTab();
  $('#add-row').on('click', function() {
      addInputs();
  });
});

$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});
var category = new function() {
    var me = this;
    this.containerAmong;
    this.durningRequest = false;

    this.showNext = function(el) {
        var categoryBox = $(el).closest("[data-category-box]");
        var currentPage = parseInt(categoryBox.attr("data-category-currentpage"));
        var container = categoryBox.find("[data-category-container]");
        /*if (container.eq(currentPage).length > 0) {
            container.eq(currentPage).fadeIn();
        }
        if (container.eq(currentPage + 1).length == 0) {
            $(el).fadeOut();
        }
        $(el).closest("[data-category-box]").attr("data-category-currentpage", currentPage + 1);*/
        var data = {
            category_id: categoryBox.data("category-id"),
            page_nr: parseInt(categoryBox.data("category-page")) + 1,
            _token: Laravel.csrfToken,
            language: $('html').attr('lang')
        };

        if(typeof categoryBox.find("[data-category-thumbnail]")!=="undefined" && categoryBox.attr("data-category-thumbnail")!=""){
          data.thumbnail = categoryBox.attr("data-category-thumbnail");
        }

        if(typeof categoryBox.find("[data-module]")!=="undefind"){
          data.module = categoryBox.attr("data-module");
        }

        if(typeof categoryBox.find("[data-listing]")!=="undefind"){
          data.listing = categoryBox.attr("data-listing");
        }

        var requestParams = document.location.href.split('/').pop().split(',');
        if(requestParams.length > 1 && parseInt(requestParams[1])>=1 && parseInt(requestParams[1])<=12)
          data.month = requestParams[1];
        if(requestParams.length == 2)
          data.year = requestParams[1];
        else if(requestParams.length > 2)
          data.year = requestParams[2];

        if(!me.durningRequest)
          me.getPosts(data,categoryBox);
    };

    /**
     * data:
     *  category_id
     *  page_nr
     *  _token
     */
    this.getPosts = function(data,categoryBox){
      me.durningRequest = true;
      $.ajax({
          url: "/module/postfromcategory",
          method: "POST",
          data: data,
          dataType: "json",
          success: function (data) {
              if (data.posts.length == 0) {
                  $("[data-category-loadpage]").remove();
              } else {
                  var template = $("#entry-template").html();
                  var stone = Handlebars.compile(template)(data);
                  var $items = $.parseHTML(stone);
                  if(data.posts.length<parseInt(categoryBox.data('category-perpage')))
                    $("[data-category-loadpage]").remove();

                  categoryBox.find("[data-category-container]").append($items);
                  categoryBox.data('category-page', data.page);
                  $(".loader").data("offset", data.offset);
              }
              me.durningRequest = false;

              if(data.next==0)
                categoryBox.find('div[data-category-loadpage]').addClass('hidden');
          }
      });
    };

    this.bindEvents = function() {
        $("[data-category-loadpage]").bind("click", function() {
            me.showNext($(this));
        });
    };

};

$(document).ready(function () {
    if (document.querySelector('[data-category-loadpage]'))
      category.bindEvents();

    if (document.querySelector('.loader')){
      $('.loader').on('inview', function (event, isInView) {
          if (isInView) {
              var data = {
                  category_id: $("[data-category-id]").data("category-id"),
                  page_nr: parseInt($("[data-category-page]").data("category-page")) + 1,
                  _token: Laravel.csrfToken
              };

              category.getPosts(data);
          }
      });
    }
});

Handlebars.registerHelper('dotdotdot', function(str,length) {
  if (str.length > length)
    return str.substring(0,length-1) + '...';
  return str;
});

Handlebars.registerHelper('compare', function (v1, operator, v2, options) {
   'use strict';
   console.log(options);
   var operators = {
     '==': v1 == v2 ? true : false,
     '===': v1 === v2 ? true : false,
     '!=': v1 != v2 ? true : false,
     '!==': v1 !== v2 ? true : false,
     '>': v1 > v2 ? true : false,
     '>=': v1 >= v2 ? true : false,
     '<': v1 < v2 ? true : false,
     '<=': v1 <= v2 ? true : false,
     '||': v1 || v2 ? true : false,
     '&&': v1 && v2 ? true : false
   }
   if (operators.hasOwnProperty(operator)) {
     if (operators[operator]) {
       return options.fn(this);
     }
     return options.inverse(this);
   }
   return console.error('Error: Expression "' + operator + '" not found');
});

Handlebars.registerHelper('indexof', function(array,index) {
  if(array.length > index)
    return array[index];
  else
    return "";
});

Handlebars.registerHelper('slugify', function(value) {
  return this[value].toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-');
});

$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
      $(this).find('a').append('<span class="mobileMenu__submenuSwitcher"></span>');
    }
  });
  

  function submenuSwitcher() {
    $("[data-menu] .mobileMenu__submenuSwitcher").on("click", function (e) {
        if ($(e.target).hasClass('mobileMenu__submenuSwitcher')) {
          e.preventDefault();
          var el = $(this).parent();
          el.toggleClass("actived");
          el.next('ul').toggleClass("opened");
        }
    });
  }
  submenuSwitcher();

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

// main slider
var nextSlide = window.Laravel.lang.slider.next;
var prevSlide = window.Laravel.lang.slider.prev;

document.addEventListener('DOMContentLoaded', function () {
  const swiper = new Swiper('.swiper-workin', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: '-25',
    centeredSlides: true,
    slideToClickedSlide: true,
    pagination: {
      el: '.swiper-workin .swiper-pagination',
      clickable: true
    },

    navigation: {
      nextEl: '.swiper-workin-next',
      prevEl: '.swiper-workin-prev'
    },

    breakpoints: {
      992: {
        slidesPerView: 3
      }
    }
  });

  if ( $(".swiper-workin").length ) {
    const $workinSwiper = $(".swiper-workin");

    $workinSwiper.on('click', 'a', function (e) {
      const $slide = $(this).closest('.swiper-slide');
      if (!$slide.hasClass('swiper-slide-active')) {
        e.preventDefault();
        e.stopPropagation();

        const realIndexAttr = $slide.attr('data-swiper-slide-index');
        const realIndex = realIndexAttr != null ? parseInt(realIndexAttr, 10) : null;
        if (realIndex != null && !Number.isNaN(realIndex)) {
          swiper.slideToLoop(realIndex);
        }
      }
    });

    $workinSwiper.magnificPopup({
      delegate: 'a',
      type: 'image',
      mainClass: 'mfp-with-zoom',
      removalDelay: 400,
      gallery: {
        enabled: true
      }
    });
  }

  const testimonialsEl = document.querySelector('.homeTestimonials__slider.swiper');
  if (testimonialsEl) {
    const testimonialsList = testimonialsEl.querySelector('.homeTestimonials__list');
    const testimonialsMq = window.matchMedia('(max-width: 767px)');
    let testimonialsSwiper = null;

    function syncTestimonialsSwiper() {
      if (testimonialsMq.matches && !testimonialsSwiper) {
        testimonialsList.classList.add('swiper-wrapper');
        testimonialsSwiper = new Swiper(testimonialsEl, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 24,
          pagination: {
            el: testimonialsEl.querySelector('.swiper-pagination'),
            clickable: true
          }
        });
      } else if (!testimonialsMq.matches && testimonialsSwiper) {
        testimonialsSwiper.destroy(true, true);
        testimonialsSwiper = null;
        testimonialsList.classList.remove('swiper-wrapper');
      }
    }

    syncTestimonialsSwiper();
    testimonialsMq.addEventListener('change', syncTestimonialsSwiper);
  }
});


// imageslider
var elements = document.querySelectorAll('.js-sliderGallery');
if (elements.length > 0) {
  $('.js-sliderGallery').slick({
    arrows: true,
    speed: 700,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: true,
    slidesPerRow: 5,
    rows: 2,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesPerRow: 2,
          rows: 2,
        }
      }
    ]
  });
}


//logoSlider
if ($('.js-logoSlider').length) {
  $('.js-logoSlider').slick({
    arrows: true,
    speed: 700,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 900,
        adaptiveHeight: false,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
      ,
      {
        breakpoint: 600,
        adaptiveHeight: true,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
//productSlider
if ($('.js-productSlider').length) {
  $('.js-productSlider').slick({
    speed: 700,
    fade: true,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          dots: false
        }
      }
    ]
  });
}

function setTimeSlider() {
  let sliderOpac = $('.slider');
  sliderOpac.addClass('sliderShow');
}

setTimeout(setTimeSlider, 100);

//testimonials
if ($('.homeTestimonials__slider').length) {
  // $('.homeTestimonials__slider').slick({
  //   speed: 700,
  //   fade: true,
  //   autoplaySpeed: 7000,
  //   dots: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   infinite: true,
  //   autoplay: false,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 1240,
  //       settings: {
  //         dots: false
  //       }
  //     }
  //   ]
  // });
}

let formmoduleInitialized = false;
function checkDepend(element){
  var elementId = element.attr('data-formmodule-element');
  var clearDepend = false;
  if($("[data-formmodule-depend='"+elementId+"']").length>0){
    var dependElement = $("[data-formmodule-depend='"+elementId+"']");
    var inputType = element.prop('tagName').toLowerCase();

    if(inputType!="select")
      inputType = element.attr('type');

    var value = false;
    if(inputType == "select"){
      value = element.find('option:selected').val()!="";
    }else if(inputType=="checkbox" || inputType=="radio"){
      value = element.is(':checked');
    }else{
      value = element.val()!="";
    }

    if(inputType=="select")
      element = element.find('option:selected');

    var dependValues = new Array();
    for(var i=0;i<dependElement.length;i++)
      dependValues = dependValues.concat(dependElement.eq(i).attr('data-formmodule-depend-value').split('|'));

    if(value){
      // console.log(inputType);
      // console.log(dependValues);
      // console.log(dependElement);
      // console.log(element.attr('data-value-id'));
      // console.log(dependElement.attr('data-formmodule-depend-value'));
      // console.log(element.val());


      if(inputType=="radio" || inputType=="select" || inputType=="checked"){
        dependElement.css('display','none');
        dependElement.find('[required]').removeAttr('required');
      }

      if(
        (['select','radio','checkbox'].includes(inputType) && dependValues.includes(element.attr('data-value-id')))
          ||
        (dependElement.attr('data-formmodule-depend-value') === element.val())
      ){
          if(element.attr('data-value-id') === undefined){
            dependElement.css('display','block');
            dependElement.find('[data-required]').each(function(i,el){
              if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                $(el).attr('required','required');
              else
                $(el).removeAttr('required');
            });
          }

          var dependValueElement = $("[data-formmodule-depend-value="+element.attr('data-value-id')+"]");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }

          var dependValueElement = $("[data-formmodule-depend-value^='"+element.attr('data-value-id')+"|']");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }

          var dependValueElement = $("[data-formmodule-depend-value*='|"+element.attr('data-value-id')+"|']");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }

          var dependValueElement = $("[data-formmodule-depend-value$='|"+element.attr('data-value-id')+"']");
          if(dependValueElement){
              dependValueElement.css('display','flex');
              dependValueElement.find('[data-required]').each(function(i,el){
                if(typeof $(el).attr('data-required') !== "undefined" && parseInt($(el).attr('data-required'))==1)
                  $(el).attr('required','required');
                else
                  $(el).removeAttr('required');
              });
          }
      }else{
        if(element.attr('data-value-id') === undefined){
          dependElement.css('display','none');
          dependElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value="+element.attr('data-value-id')+"]");
        clearDepend = true;
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value^='"+element.attr('data-value-id')+"|']");
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value*='|"+element.attr('data-value-id')+"|']");
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }

        var dependValueElement = $("[data-formmodule-depend-value$='|"+element.attr('data-value-id')+"']");
        if(dependValueElement){
          dependValueElement.css('display','none');
          dependValueElement.find('[required]').removeAttr('required');
        }
      }
    }else{
      var dependValueElement = $("[data-formmodule-depend-value="+element.attr('data-value-id')+"]");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }

      var dependValueElement = $("[data-formmodule-depend-value^='"+element.attr('data-value-id')+"|']");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }

      var dependValueElement = $("[data-formmodule-depend-value*='|"+element.attr('data-value-id')+"|']");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }

      var dependValueElement = $("[data-formmodule-depend-value$='|"+element.attr('data-value-id')+"']");
      if(dependValueElement){
        dependValueElement.css('display','none');
        dependValueElement.find('[required]').removeAttr('required');
      }
    }

    if(clearDepend){
      if(dependElement.find('select').length>0){
        //dependElement.find('select').prop('selectedIndex', -1);
        dependElement.find('select').val('');
      }else if(dependElement.find('input[type="radio"]').length>0 || dependElement.find('input[type="checkbox"]').length>0){
        dependElement.find('input').prop('checked', false);
      }else{
        dependElement.find('input').val('');
        dependElement.find('textarea').val('');
      }
      dependElement.find('select').trigger('change');
      dependElement.find('input').trigger('keyup');
      dependElement.find('input').trigger('change');
      dependElement.find('textarea').trigger('change');
    }else if(dependElement.length>1){
      if(formmoduleInitialized){
        setTimeout(function(){
          for(var i=0; i< dependElement.length;i++){
            if(!dependElement.eq(i).is(':visible'))
              if(dependElement.eq(i).find('select').length>0){
                // dependElement.eq(i).find('select').prop('selectedIndex', -1);
                dependElement.find('select').val('');
              }else if(dependElement.eq(i).find('input[type="radio"]').length>0 || dependElement.eq(i).find('input[type="checkbox"]').length>0){
                dependElement.eq(i).find('input').prop('checked', false);
              }else{
                dependElement.eq(i).find('input').val('');
                dependElement.eq(i).find('textarea').val('');
              }
              dependElement.eq(i).find('select').trigger('change');
              dependElement.eq(i).find('input').trigger('keyup');
              dependElement.eq(i).find('input').trigger('change');
              dependElement.eq(i).find('textarea').trigger('change');
          }
        },800);
      }
    }
  }
}

function checkMsg(element){
  var msg = element.attr('data-choose-msg');
  element.closest('[data-form-row]').find('.formErrors').css('display','none');

  var inputType = element.prop('tagName').toLowerCase();
  if(inputType!="select" && inputType!="option")
    inputType = element.attr('type');
  var used = false, value = "";
  if(inputType == "select" || inputType == "option"){
    used = element.is(':checked')
    value = element.val();
  }else if(inputType=="checkbox" || inputType=="radio"){
    used = $("#"+element.attr('id')).is(':checked');
    value = element.val();
  }else{
    used = true;
    value = element.val();
  }

  if(used && value!=""){
    if(typeof msg !== "undefined" && msg!=""){
      element.closest('[data-form-row]').find('.formErrors li').html(msg);
      element.closest('[data-form-row]').find('.formErrors').css('display','block');
    }

    if(
        (typeof element.attr('data-formmodule-minvalue')!=="undefined" && value!="" && typeof element.attr('data-formmodule-minvaluemsg')!=="undefined" && element.attr('data-formmodule-minvaluemsg')!="")
        ||
        (inputType=="option" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-minvalue')!=="undefined" && value!="" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-minvaluemsg')!=="undefined" && element.attr('data-formmodule-minvaluemsg')!="")
    ){
      var showMsg = false, messages = typeof element.attr('data-formmodule-minvaluemsg')!=="undefined" ? element.attr('data-formmodule-minvaluemsg').split('|') : [];
      if(inputType=="date" || element.attr('data-formmodule-element-type')=="date"){
        minDates = element.attr('data-formmodule-minvalue').split('|');
        if(value.indexOf('.')!==-1)
          inputValue = value.split('.');
        else
          inputValue = value.split('-');
        inputValue = inputValue[2]+"-"+inputValue[1]+"-"+inputValue[0];
        inputDate = new Date(inputValue);
        inputDate.setHours(0,0,0);
        for(var i=0;i<minDates.length;i++){
          minDate = minDates[i];
          if(minDate.indexOf('.')!==-1)
            minDate = minDate.split('.');
          else
            minDate = minDate.split('-');
          minDate = minDate[2]+"-"+minDate[1]+"-"+minDate[0];
          minDate = new Date(minDate);
          minDate.setHours(0,0,0);
          if(inputDate<minDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="month"|| element.attr('data-formmodule-element-type')=="month"){
        minDates = element.attr('data-formmodule-minvalue').split('|');
        inputDate = new Date(value+'-01');
        inputDate.setHours(0,0,0);
        for(var i=0;i<minDates.length;i++){
          minDate = minDates[i];
          minDate = minDate.split('-');
          minDate = new Date(minDate);
          minDate.setHours(0,0,0);

          if(inputDate<minDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="number"){
        mins = element.attr('data-formmodule-minvalue').split('|');
        for(var i=0;i<mins.length;i++){
          if(value<parseFloat(mins[i])){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="option"){
        mins = element.closest('select[data-formmodule-element]').attr('data-formmodule-minvalue').split('|');
        for(var i=0;i<mins.length;i++){
         if(value<mins[i]){
           showMsg = true;
           msg = messages[i];
           break;
         }
       }
      }else{
        mins = element.attr('data-formmodule-minvalue').split('|');
        for(var i=0;i<mins.length;i++){
          if(value<mins[i]){
            showMsg = true;
            msg = messages[i];
            break;
          }
        }
      }

      if(showMsg){
        if(typeof msg !== "undefined" && msg!=""){
          element.closest('[data-form-row]').find('.formErrors li').html(msg);
          element.closest('[data-form-row]').find('.formErrors').css('display','block');
        }
      }
    }

    showMsg = false;
    messages = typeof element.attr('data-formmodule-maxvaluemsg')!=="undefined" ? element.attr('data-formmodule-maxvaluemsg').split('|') : [];
    if(
        (typeof element.attr('data-formmodule-maxvalue')!=="undefined" && value!="" && typeof element.attr('data-formmodule-maxvaluemsg')!=="undefined" && element.attr('data-formmodule-maxvaluemsg')!="")
        ||
        (inputType=="option" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-maxvalue')!=="undefined" && value!="" && typeof element.closest('select[data-formmodule-element]').attr('data-formmodule-maxvaluemsg')!=="undefined" && element.attr('data-formmodule-maxvaluemsg')!="")
    ){
      var showMsg = false;
      if(inputType=="date" || element.attr('data-formmodule-element-type')=="date"){
        maxDates = element.attr('data-formmodule-maxvalue').split('|');
        if(value.indexOf('.')!==-1)
          inputValue = value.split('.');
        else
          inputValue = value.split('-');
        inputValue = inputValue[2]+"-"+inputValue[1]+"-"+inputValue[0];
        inputDate = new Date(inputValue);
        inputDate.setHours(0,0,0);

        for(var i=0;i<maxDates.length;i++){
          maxDate = maxDates[i];
          maxDate = minDates[i];
          if(maxDate.indexOf('.')!==-1)
            maxDate = maxDate.split('.');
          else
            maxDate = maxDate.split('-');
          maxDate = maxDate[2]+"-"+maxDate[1]+"-"+maxDate[0];

          maxDate = new Date(maxDate);
          maxDate.setHours(0,0,0);

          if(inputDate>maxDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="month"|| element.attr('data-formmodule-element-type')=="month"){
        maxDates = element.attr('data-formmodule-maxvalue').split('|');
        inputDate = new Date(value+'-01');
        inputDate.setHours(0,0,0);

        for(var i=0;i<maxDates.length;i++){
          maxDate = maxDates[i];
          maxDate = new Date(maxDate);
          maxDate.setHours(0,0,0);
          if(inputDate>maxDate){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="number"){
        maxs = element.attr('data-formmodule-maxvalue').split('|');
        for(var i=0;i<maxs.length;i++){
          if(value>parseFloat(maxs[i])){
            msg = messages[i];
            showMsg = true;
            break;
          }
        }
      }else if(inputType=="option"){
        maxs = element.closest('select[data-formmodule-element]').attr('data-formmodule-maxvalue').split('|');
        for(var i=0;i<maxs.length;i++){
         if(value>maxs[i]){
           showMsg = true;
           msg = messages[i];
           break;
         }
       }
      }else{
        maxs = element.attr('data-formmodule-maxvalue').split('|');
        for(var i=0;i<maxs.length;i++){
          if(value>maxs[i]){
            showMsg = true;
            msg = messages[i];
            break;
          }
        }
      }

      if(showMsg){
        if(typeof msg !== "undefined" && msg!=""){
          element.closest('[data-form-row]').find('.formErrors li').html(msg);
          element.closest('[data-form-row]').find('.formErrors').css('display','block');
        }
      }
    }
  }
}

function init(){
  $("input[data-formmodule-element]").trigger('keyup');
  $("select[data-formmodule-element]").trigger('change');
  $("input[data-formmodule-element]").trigger('change');
  formmoduleInitialized = true;
}

$(document).ready(function(){
  $("select[data-formmodule-element]").on('select2:select', function (e) {
    checkDepend($(this));
    checkMsg($(this).find('option:selected'))
  });
  if($("select[data-formmodule-element]").length>0){
    $("select[data-formmodule-element]").bind('change',function(){
      checkDepend($(this));
      checkMsg($(this));
    });
  }
  $("input[data-formmodule-element]").bind('click',function(){
    checkDepend($(this));
    checkMsg($(this));
  });
  $("input[data-formmodule-element]").bind('change',function(){
    checkDepend($(this));
    checkMsg($(this));
  });
  $("input[data-formmodule-element],textarea[data-formmodule-element]").bind('keyup',function(){
    var el = $(this).parent().find('[data-formmodule-charlimit]');
    if(el.length){
      el.html(parseInt(el.attr('data-formmodule-charlimit')) - $(this).val().length);
    }
  });
  $("select[data-formmodule-monthyear],select[data-formmodule-monthmonth]").on('select2:select',function(){
    var year = $(this).closest("[data-form-row]").find("select[data-formmodule-monthyear]").find('option:selected').val();
    var month = $(this).closest("[data-form-row]").find("select[data-formmodule-monthmonth]").find('option:selected').val();
    $(this).closest("[data-form-row]").find('input[data-formmodule-element]').val(year+"-"+month);
    $(this).closest("[data-form-row]").find('input[data-formmodule-element]').trigger('change');
  });
  // $("input[data-formmodule-element]").bind('keyup',function(){
  //   checkDepend($(this));
  //   checkMsg($(this));
  // });
  $("input[data-formmodule-element][type='checkbox']").bind('change',function(){
    var group = $(this).closest('[data-form-row]');
    var checked = group.find('input:checked').length;
    if(checked>0){
      group.find('input').removeAttr('required');
    }else if(typeof group.attr('required')!="undefined"){
      group.find('input').attr('required','required');
    }
  });
  init();
});



$(".calendar").datepicker({
  format:'dd.mm.yyyy',
  language: $('html').attr('lang'),
  autoclose: true
});



$('input.timepicker').timepicker({
  timeFormat: 'H:mm ',
  interval: 60,
  minTime: '00',
  maxTime: '23',
  startTime: '10:00',
  dynamic: false,
  dropdown: true,
  scrollbar: true
});


var placeholderYears = window.Laravel.lang.forms.yearPlaceholder;
var placeholderMonth = window.Laravel.lang.forms.monthPlaceholder;

$('.monthCalendar__selects-years').select2({
    placeholder: placeholderYears
});

$('.monthCalendar__selects-month').select2({
   placeholder: placeholderMonth
});


  // file input

  const dt = []; // Permet de manipuler les fichiers de l'input file

  $("[data-form-file]").on('change', function(e){
    var elementId = $(this).closest("[data-form-row]").attr("data-form-row");
    if(typeof dt[elementId] === "undefined")
      dt[elementId] = new DataTransfer();

  	for(var i = 0; i < this.files.length; i++){
  		let fileBloc = $('<span/>', {class: 'file-block'}),
  			 fileName = $('<span/>', {class: 'name', text: this.files.item(i).name});
  		fileBloc.append('<span class="file-delete"><span class="iconDel"></span></span>')
  			.append(fileName);
  		$(this).closest(".files").find("#filesList > #files-names").append(fileBloc);
  	};
  	for (let file of this.files) {
  		dt[elementId].items.add(file);
  	}

  	this.files = dt[elementId].files;

  	$('span.file-delete').click(function(){
      var container = $(this).closest("[data-form-row]");
      var elementId = container.attr("data-form-row");

  		let name = $(this).next('span.name').text();
  		$(this).parent().remove();
  		for(let i = 0; i < dt[elementId].items.length; i++){
  			if(name === dt[elementId].items[i].getAsFile().name){
  				dt[elementId].items.remove(i);
  				continue;
  			}
  		}
      container.find('[data-form-file]')[0].files = dt[elementId].files;
  	});
  });

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){

  // wcag panel
    $('#wcagIcon').on('click', function() {
        $('#wcagPanel').toggleClass('opened')
    });

    $('.wcag__close').on('click', function() {
        $('#wcagPanel').removeClass('opened')
    });

  if(typeof sessionStorage["fontsize"] === "undefined")
    sessionStorage['fontsize'] = 0;

  var size = 0;
  $('.wcagFontsMinus').on("click", function () {
    if(size>-3 || size == 0){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) - 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) - 1);
      });
      size--;
    }
  });
  $('.wcagFontsPlus').on("click", function () {
    if(size<6){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) + 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) + 1);
      });
      size++;
    }
  });

  $('.wcagFontsReset').on("click", function () {
    sessionStorage['fontsize'] = 0;
    $('*').each(function(){
      $(this).css('font-size','');
    });
    size = 0;
  });

  $('.wcagFontsReads').on("click", function () {
      $('body').toggleClass('is_arial')
  });
  $('.wcagLinkUndeline').on("click", function () {
      $('body').toggleClass('is_underline')
  });
  $('.wcagLinkLighting').on("click", function () {
    $('body').toggleClass('is_lighting')
  });

  $('.wcagLinkReset ').on("click", function () {
    $('body').removeClass('is_lighting');
    $('body').removeClass('is_underline');
  });



  $('#wcagContrast-yellowBlack').on("click", function () {
    $('body').removeClass('blackYellow');
    $('body').removeClass('blackWhite');
    $('body').removeClass('whiteBlack');
    $('body').addClass('yellowBlack');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 1;
    }
  });


  $('#wcagContrast-blackYellow').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('whiteBlack');
    $('body').addClass('blackYellow');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 1;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });


  $('#wcagContrast-blackWhite').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('whiteBlack');
    $('body').removeClass('blackYellow');
    $('body').addClass('blackWhite');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 1;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-whiteBlack').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('blackYellow');
    $('body').addClass('whiteBlack');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 1;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-reset').on("click", function () {
    sessionStorage["blackYellow"] = 0;
    sessionStorage["blackWhite"] = 0;
    sessionStorage["whiteBlack"] = 0;
    sessionStorage["yellowBlack"] = 0;
    $('body').removeClass();
  });





    // Check if sessionStorage is supported
      if ('sessionStorage' in window && typeof sessionStorage == 'object') {
          if(parseInt(sessionStorage["fontsize"])!=0){
            var elements = $('*');
            var sizes = [];
            for(var i=0;i<elements.length;i++)
                sizes[i] = parseInt(elements.eq(i).css('font-size')) + parseInt(sessionStorage['fontsize']);
            for(var i=0;i<elements.length;i++)
              elements.eq(i).css('font-size', sizes[i]);
          }
          size = parseInt(sessionStorage['fontsize']);

          ["blackYellow","blackWhite","whiteBlack","yellowBlack"].forEach(function(element){
            if(parseInt(sessionStorage[element])==1){
              $('body').removeClass();
              $('#wcagContrast-'+element).trigger('click');
            }
          });
      }

      });

const dataTransfer = new DataTransfer(); // Allows you to manipulate files in the input file

$(".classInputFile").on('change', function(e){
	for(var i = 0; i < this.files.length; i++){
		let fileBloc = $('<span/>', {class: 'file-block'}),
			 fileName = $('<span/>', {class: 'name', text: this.files.item(i).name});
		fileBloc.append('<span class="file-delete"><span class="iconDel"></span></span>')
			.append(fileName);
		$(".filesList > .files-names").append(fileBloc);
	};
	// Adding files to the DataTransfer object
	for (let file of this.files) {
		dataTransfer.items.add(file);
	}
	// Update input file files after adding
	this.files = dataTransfer.files;

	// EventListener for the created delete button
	$('span.file-delete').click(function(){
		let name = $(this).next('span.name').text();
		// Remove file name display
		$(this).parent().remove();
		for(let i = 0; i < dataTransfer.items.length; i++){
			// File and name matching
			if(name === dataTransfer.items[i].getAsFile().name){
				// Deleting file in DataTransfer object
				dataTransfer.items.remove(i);
				continue;
			}
		}
		//Updating input file files after deletion
			$(this).cloest('.files').find('input')[0].files = dataTransfer.files
	});
});

$(document).ready(function(){



  var selectPlaceholder = window.Laravel.lang.forms.selectPlaceholder;

  $('.select').select2({
     placeholder: selectPlaceholder,
     minimumResultsForSearch: Infinity, // hide search field,
     language: {
       "noResults": function(){
           return window.Laravel.lang.empty_select;
       }
     }
  });

  $(".select-search").select2({
    //minimumResultsForSearch: 0,
    language: {
      "noResults": function(){
        return window.Laravel.lang.empty_select;
      }
    },
    matcher: function(params, data) {
        if ($.trim(params.term) === '')
          return data;

        if (typeof data.text === 'undefined')
          return null;

        if (data.text.toLowerCase().indexOf(params.term.toLowerCase()) > -1) {
          var modifiedData = $.extend({}, data, true);
          //modifiedData.text += ' (matched)';
          return modifiedData;
        }

        return null;
    },
    templateSelection: function(data) {
      // if(data.selected) //nie wybiera po kliku lub enterze po wyszukiwaniu
        return data.text.trim();
    },
    tokenSeparators: [',', ' ']
  });


  var sortPlaceholder = window.Laravel.lang.offer.sort;

  $('#sortProducts').select2({
      placeholder: sortPlaceholder,
      minimumResultsForSearch: Infinity // hide search field
  });



  $(".filtrPrice .mutliSelect__name").on('click', function() {
    $(".filtrPrice ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrQuality ul").hide();
    $(".filtrSort ul").hide();

  });

  $(".filtrColor .mutliSelect__name").on('click', function() {
    $(".filtrColor ul").slideToggle('fast');
    $(".filtrQuality ul").hide();
    $(".filtrSort ul").hide();
    $(".filtrPrice ul").hide();
  });
  $(".filtrQuality .mutliSelect__name").on('click', function() {
    $(".filtrQuality ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrSort ul").hide();
    $(".filtrPrice ul").hide();


  });
  $(".filtrSort .mutliSelect__name").on('click', function() {
    $(".filtrSort ul").slideToggle('fast');
    $(".filtrColor ul").hide();
    $(".filtrQuality ul").hide();
    $(".filtrPrice ul").hide();

  });

  $(document).bind('click', function(e) {
    var $clicked = $(e.target);
    if (!$clicked.parents().hasClass("mutliSelectWrap")) $(".mutliSelectWrap ul").hide();
  });



});

!function(a){
  if (a && a.fn && a.fn.datepicker && a.fn.datepicker.dates) {
    a.fn.datepicker.dates.pl = {
      days: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
      daysShort: ["Niedz.", "Pon.", "Wt.", "Śr.", "Czw.", "Piąt.", "Sob."],
      daysMin: ["Ndz.", "Pn.", "Wt.", "Śr.", "Czw.", "Pt.", "Sob."],
      months: ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"],
      monthsShort: ["Sty.", "Lut.", "Mar.", "Kwi.", "Maj", "Cze.", "Lip.", "Sie.", "Wrz.", "Paź.", "Lis.", "Gru."],
      today: "Dzisiaj",
      weekStart: 1,
      clear: "Wyczyść",
      format: "dd.mm.yyyy"
    }
  }
}(jQuery);

$(document).ready(function(){

  $(".calendar").datepicker({
    format:'dd.mm.yyyy',
    language: 'pl-PL',
    autoclose: true
  });


  $('.timepicker').timepicker({
    timeFormat: 'H:mm ',
    interval: 60,
    minTime: '00',
    maxTime: '23',
    startTime: '10:00',
    dynamic: false,
    dropdown: true,
    scrollbar: true
  });

});

$(document).ready(function(){

  $('.header__login-withSubmenu').on('click', function(){
      $('.header__login-submenu').slideToggle(300);
  });

  $('.myAcc').on('click', function(){
      event.preventDefault();
  });


  //  obcicnanie dlugiego textu w opisie blogu

  $(".blogItem__desc").text(function(i, text) {
    if (text.length >= 165) {
      text = text.substring(0, 165);
      var lastIndex = text.lastIndexOf(" ");
      text = text.substring(0, lastIndex) + '...';
    }
    $(this).text(text);

  });


  // anchor animate
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();

          document.querySelector(this.getAttribute('href')).scrollIntoView({
              behavior: 'smooth'
          });
      });
  });

  if ( $(".mfi").length ) {
      $(".mfi").magnificPopup({
          mainClass: 'mfp-with-zoom',
          removalDelay: 400,
          type: "inline"
      });
  }

  //  hide/show password

  $('body').on('click', '.password-control', function(){
    if ($('#password').attr('type') == 'password'){
    $(this).addClass('view');
    $('#password').attr('type', 'text');
    } else {
    $(this).removeClass('view');
    $('#password').attr('type', 'password');
    }
    return false;
  });

  $('body').on('click', '.password-confirmation-control', function(){
    if ($('#password_confirmation').attr('type') == 'password'){
    $(this).addClass('view');
    $('#password_confirmation').attr('type', 'text');
    } else {
    $(this).removeClass('view');
    $('#password_confirmation').attr('type', 'password');
    }
    return false;
  });


  //if Sidebar exists
  // if ( $('.main__sidebar').length ) {
  //   $('.offerBoxes').addClass('offerBoxes--withSidebar');
  // }

  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }

  //language - select
  if ($('.languageBox__select').length) {
    $('.languageBox__select').on('click', function() {
        $('.languageBox__list').toggleClass('visible');


        return false;
    });
  }

  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
  }

  // lazy loads elements with default selector as '.lozad'
  if ($('.lozad').length) {
    const observer = lozad();
    observer.observe();
  }

  // Handle Lazy loading on page print
  window.onbeforeprint = function() {
    $('.lozad').each(function() {
      var src = $(this).attr('data-src');
      $(this).attr('src', src).parent().addClass('loaded');
    });
  };

  // scrolled menu
  if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
  }

  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        wrapper: '.rellax-parent',
        relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });


  //go to map
  if ($('.js-gotomap').length) {
    $('.js-gotomap').on('click', function(){
        let anchor = $('.contact__map');
        if (anchor.length) {
            $('html, body').animate({
                scrollTop:  $(anchor).offset().top - 100
            }, 600);
            return false;
        }
    });
  }

  // scrolled menu
  if ($(window).scrollTop() > 0){
    $('.js-header').addClass('header--scrolled');
   } else {
    if ($(window).width()>1240){
      $('.js-header').removeClass('header--scrolled');
    }
  }


  //search
  $('.js-header__search').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });
  $('.header .searchBox .searchBox__close').on('click', function(){
      $('.header .searchBox').slideToggle(300);
  });

  $('.searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });

  //filters in offer
  if ($("[data-filter-submit]").length) {
    $("[data-filter-submit]").click(function(){
      var filters = $("[data-filter]"),name,value,counter=1,type;
      var url = top.location.href.split(",");
      var checkedFilters = new Array();
      var filterOperators = [];
      url = url[0]+",1&";
      for(var i=0;i<filters.length;i++){
        id = filters.eq(i).attr('data-filter');
        name = filters.eq(i).attr('data-filter-field');
        type = filters.eq(i).attr('type');
        operator = filters.eq(i).attr('data-filter-operator');
        if(typeof operator === "undefined") operator = "";

        if (!filterOperators.includes(name+"_"+operator)) {
          value = "";
          if($("[data-filter='"+id+"']").length>1){ //&& type!="number") {
            var subFilters = $("[data-filter-field='"+name+"']");
            for(var j=0;j<subFilters.length;j++){
              if(type=="checkbox"){
                value+= subFilters.eq(j).is(":checked") ? subFilters.eq(j).val()+"," : "";
              }else if(subFilters.eq(j).val()!=""){
                value+= subFilters.eq(j).val()+",";
              }
            }
            if(value[value.length-1] == ","){
              value = value.slice(0,-1);
            }
          }else if(type=="checkbox"){
            value = filters.eq(i).is(":checked") ? filters.eq(i).val() : "";
          }else{
            value = filters.eq(i).val();
            if(value===null)
              value = "";
          }

          if(typeof value!=="undefined" && value!="" && value!=","){
            if(typeof filters.eq(i).attr('data-filter-name')==="undefined"){
              url+= "filter_" + counter + "=" + name + "&value_" + counter + "=" + value;
              if(typeof filters.eq(i).attr('data-filter-operator')!=="undefined"){
                url+= "&operator_" + counter + "=" + filters.eq(i).attr('data-filter-operator');
                filterOperators.push(name+"_"+operator);
              }else{
                filterOperators.push(name+"_");
              }
              url+="&";
              counter++;
            }else{
              url+= filters.eq(i).attr('data-filter-name') + "=" + value+"&";
              filterOperators.push(name+"_");
            }
          }

          checkedFilters.push(name);
        }
      }
      var sort = $("[data-filter-sort]").find("option:selected").val();
      if(typeof sort!=="undefined" && sort!=""){
        url+= "sort="+$("input[name='sort']").val()+"&";
        url+= "sort_order="+$("input[name='sort_order']").val()+"&";
      }

      if(url[url.length-1] == "&"){
        url = url.slice(0,-1);
      }
      top.location.href = url;
    });

    $("[data-filter-sort]").change(function(){
      $("input[name='sort_order']").val($(this).find('option:selected').attr('data-sort-order'));
      $("input[name='sort']").val($(this).find('option:selected').attr('data-sort-field'));
      $("[data-filter-submit]").trigger('click');
    });

    function updateFilterCounter(el,counter){
      el.closest(".mutliSelectWrap").find("[data-filter-choosedcounter]").html(counter);
      if(counter>0){
        el.closest(".mutliSelectWrap").addClass('activeCheck');
        el.closest(".mutliSelectWrap").find("[data-filter-choosedcounter]").show();
      }else{
        el.closest(".mutliSelectWrap").removeClass('activeCheck');
        el.closest(".mutliSelectWrap").find("[data-filter-choosedcounter]").hide();
      }
    }

    $("input[type='checkbox'][data-filter]").bind('click',function(){
      var counter = $(this).closest(".mutliSelect").find("input:checked").length;
      var el = $(this);
      updateFilterCounter(el,counter);
    });

    $("input[type='text'][data-filter]").bind('keyup',function(){
      var counter = $(this).closest(".mutliSelect").find("input[data-filter]").filter(function(){
        return this.value.length>0;
      }).length;
      var el = $(this);
      updateFilterCounter(el,counter);
    });

    $("[data-filter-clear]").click(function(){
      var url = top.location.href.split(",");
      top.location.href = url[0];
    });
  }

  // sticky
  if ( $('.main__sidebar  > div').length && ( $(window).width() > 1024 ) && ( $('.main__content').height() >= $('.main__sidebar  div[data-sticky-class]').height()) )  {
    let sticky = new Sticky('.main__sidebar  > div');
  }


// acordeon
let question = document.querySelectorAll(".question");

question.forEach(question => {
  question.addEventListener("click", event => {
    const active = document.querySelector(".question.active");
    if(active && active !== question ) {
      active.classList.toggle("active");
      active.nextElementSibling.style.maxHeight = 0;
    }
    question.classList.toggle("active");
    const answer = question.nextElementSibling;
    if(question.classList.contains("active")){
      answer.style.maxHeight = answer.scrollHeight + "px";
    } else {
      answer.style.maxHeight = 0;
    }
  })
})


  // job offers filtering
  if ($('.job-offers__filters-btn').length) {
    function filterJobOffers() {
      var title = $('#jof_job_title').val().toLowerCase().trim();
      var place = $('#jof_workplace').val().toLowerCase().trim();
      var count = 0;
      $('.job-offers__list tbody tr').each(function() {
        var rowTitle = $(this).find('td[data-label="Stanowisko"]').text().toLowerCase();
        var rowPlace = $(this).find('td[data-label="Miejsce pracy"]').text().toLowerCase();
        var match = rowTitle.includes(title) && rowPlace.includes(place);
        $(this).toggle(match);
        if (match) count++;
      });
      $('.job-offers__list').toggle(count > 0);
      $('.job-offers__empty').toggle(count === 0);
    }
    $('.job-offers__filters-btn').on('click', filterJobOffers);
    $('#jof_job_title, #jof_workplace').on('keydown', function(e) {
      if (e.key === 'Enter') filterJobOffers();
    });
  }

  // job offer file input
  if ($('.styledFormItems--files').length) {
    $('.styledFormItems--files').each(function() {
      var $wrapper = $(this);
      var $input   = $wrapper.find('input[type="file"]');
      var $names   = $wrapper.find('.files-names');

      $input.on('change', function() {
        var files = this.files;
        $names.empty();
        for (var i = 0; i < files.length; i++) {
          var name = files[i].name;
          var $block = $(
            '<div class="file-block">' +
              '<span class="file-delete"><span class="iconDel"></span></span>' +
              '<span class="name">' + $('<span>').text(name).html() + '</span>' +
            '</div>'
          );
          $block.data('index', i);
          $names.append($block);
        }
      });

      $names.on('click', '.file-delete', function() {
        $input.val('');
        $names.empty();
      });
    });
  }

}); // end document ready


$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 }else {
     $(".js-header").removeClass("header--scrolled");
 }

}); // end onscroll





var message = new function() {
    this.show = function(type, message) {
        $.notify({
            message: message
        }, {
            type: type,
            placement: {
                from: "bottom",
                align: "right"
            },
            delay: 5000
        });
    };
};

var form = new function() {
    this.validate = function() {
      if(typeof $("[data-formvalidation]").validate != "undefined"){
        $("[data-formvalidation]").bind('submit',function(){
          var langs = $("[data-metagenerator-trigger]").length;
          if(langs>0){
            var elements = document.querySelectorAll("[data-metagenerator-trigger]");
            var hasValue = false;
            var errorMsg = "";
            var langId;
            if(elements.length>0)
              var parent = $("[data-metagenerator-trigger]").eq(i).closest(".tab-pane");
            for(var i=0;i<elements.length;i++){
              if(elements[i].getAttribute('disabled') === "disabled"){

              }else{
                langId = elements[i].getAttribute('data-lang-id');
                errorMsg+= elements[i].getAttribute('data-formvalidation-label') + ', ';
                if(elements[i].value!=""){
                  hasValue = true;
                  parent.find("input[name='title["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='name["+langId+"]']").addClass('requried').attr('required','required');
                  parent.find("input[name='url["+langId+"]']").addClass('requried').attr('required','required');
                }else{
                  parent.find("input[name='title["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='name["+langId+"]']").removeClass('requried').removeAttr('required');
                  parent.find("input[name='url["+langId+"]']").removeClass('requried').removeAttr('required');
                }
              }
            }

            if(!hasValue){
              message.show("danger",window.Laravel.lang.validation.insert_one_of+': '+errorMsg.trim().slice(0,-1));
              return false;
            }else{
              return true;
            }
          }else{
            return true;
          }
        });
        $("[data-formvalidation]").validate({
            "ignore": [],
            "errorPlacement": function(error, element) {
                console.log(element[0].tagName);
                if (typeof element.attr("data-lang-input") !="undefined" && element.is(":hidden")){
                  //nie pokazujemy komunikatów dla ukrytych langów
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "radio") {
                    error.insertAfter(element.parent().find('label'));
                }else if (typeof element.attr("type") != "undefined" && element.attr("type") == "file") {
                    error.insertAfter(element.parent());
                }else if(element[0].tagName.toLowerCase()=="select"){
                    error.insertAfter(element.parent().find(".select2:last"));
                } else {
                    error.insertAfter(element);
                }
            },
            "invalidHandler": function(form, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    var response = Laravel.lang.validation.invalid, msg;
                    if (validator.errorList.length > 0 && $(this).find("[data-formvalidation-label]").length > 0) {
                        response+= ":<ul>";
                        for (x = 0; x < validator.errorList.length; x++) {
                            msg = validator.errorList[x].message;
                            response+= "<li><b>"+$(validator.errorList[x].element).attr("data-formvalidation-label")+"</b> - "+msg[0].toLowerCase()+msg.slice(1,msg.length)+"</li>";
                        }
                        response+= "</ul>";
                    }

                    message.show('danger',response);
                }
            },
            "submitHandler": function(form){
              if(typeof $(form).attr("data-form-beforesubmit") != "undefined"){
                var functionName = $(form).attr("data-form-beforesubmit").split(".");
                var functionMethod = window;
                for(var i=0; i<functionName.length;i++){
                  functionMethod = functionMethod[functionName[i]];
                }

                return functionMethod();
              }
              return true;
            }
        });
      }
    };

    this.bind = function() {
        this.validate();
    };
};

$(document).ready(function() {
    if (document.querySelector('form'))
      form.bind();

    if(typeof $(".verticalcarousel").owlCarousel !== "undefined" && $(".verticalcarousel").length > 0){
      $(".verticalcarousel").owlCarousel({
          //loop: true,
          items: 1,
          nav: true,
          animateOut: 'fadeOut' 
      });
    }


    $(".sliderStatistic").slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplaySpeed: 7000,
        dots: false,
        infinite: true,
        autoplay: false,
    });


});

//# sourceMappingURL=subpage.js.map
